<script setup lang="ts">
    import { onMounted } from 'vue'
    import { onBeforeRouteUpdate, useRoute } from 'vue-router'
    import type { RouteLocationNormalizedLoaded } from 'vue-router'

    import { send } from './AppRT'

    const route = useRoute()

    function dispatch(to: RouteLocationNormalizedLoaded)
    {
        send('Runtime', 'DispatchHash', to.path)
    }

    // initial enter
    onMounted(() =>
    {
        dispatch(route)
    })

    // subsequent updates
    onBeforeRouteUpdate((to) =>
    {
        dispatch(to)
    })
</script>



<template>
    <div id="contentRoot">
        <h3 style="margin: 20px;">Launching application...</h3>
    </div>
</template>
